import type {Conjunction, CriterionOperator, Disjunction, Negation} from '../criteria.types';
import {isUndefined} from 'shared/utils/custom-utils';

export enum CRITERION_OPERATORS {
    AND = 'AND',
    OR = 'OR',
    AND_NOT = 'AND NOT'
}

export function isConjunction(operator: CriterionOperator): operator is Conjunction {
    return !isUndefined((operator as Conjunction).and);
}

export function isDisjunction(operator: CriterionOperator): operator is Disjunction {
    return !isUndefined((operator as Disjunction).or);
}

export function isNegation(operator: CriterionOperator): operator is Negation {
    return !isUndefined((operator as Negation).not);
}
